module.exports = [
  {
    "bank": "DBS BANK LTD.",
    "code": "DBSSSGSGXXX"
  },
  {
    "bank": "POSB",
    "code": "DBSSSGSGXXX"
  },
  {
    "bank": "OCBC",
    "code": "OCBCSGSGXXX"
  },
  {
    "bank": "UNITED OVERSEAS BANK LIMITED",
    "code": "UOVBSGSGXXX"
  },
  {
    "bank": "ANEXT BANK",
    "code": "ANTPSGSGXXX"
  }
]



//////////////////
// WEBPACK FOOTER
// ./static/sources/swift_codes.js
// module id = 753
// module chunks = 0